import React from 'react';
import { Box, Typography } from '@material-ui/core';

export default class NodeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || 'Render error' };
  }

  componentDidCatch() {
    /* isolated — do not crash the page */
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          p={2}
          m={1}
          style={{
            border: '1px solid #f5c6cb',
            background: '#f8d7da',
            borderRadius: 4,
          }}
        >
          <Typography variant="subtitle2" style={{ color: '#721c24' }}>
            Component error{this.props.nodeId ? ` (${this.props.nodeId})` : ''}
          </Typography>
          <Typography variant="body2" style={{ color: '#721c24' }}>
            {this.state.message}
          </Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}
